var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18.5,
    r: 18.5,
    fill: "#E4F0FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7778 17.047V13.5241C23.7778 12.9705 23.3028 12.5176 22.7222 12.5176H10.0556C9.475 12.5176 9 12.9705 9 13.5241V23.5895C9 24.1431 9.475 24.596 10.0556 24.596H22.7222C23.3028 24.596 23.7778 24.1431 23.7778 23.5895V20.0666L28 24.0927V13.0208L23.7778 17.047Z",
    fill: "#0B5CFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/video-icon.1b54750ba3e8d3adfad3bc6d13bbb502.svg";
export { ForwardRef as ReactComponent };